import { render, staticRenderFns } from "./Totens.vue?vue&type=template&id=09e5bffd&"
import script from "./Totens.vue?vue&type=script&lang=js&"
export * from "./Totens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports